<template>
  <div
    class="d-flex h-100 justify-content-around align-items-center tile"
    @click="$emit('click')"
  >
    <div class="tile__content">
      <base-icon
        class="tile__icon"
        icon="plus-m"
      />
      <div>Add image or video</div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'AddImageTile',
};
</script>
<style lang="scss"
  scoped>
  .tile {
    background-color: $gray-light;
    color: $gray-light-2;
    text-rendering: geometricPrecision;
    &__content{
      text-align: center;
      font-size: 0.75rem;
    }
    &__icon{
      opacity: 0.4;
      margin-bottom: 4px;
    }
    &:hover {
      cursor: pointer;
      opacity: 0.6;
    }
  }
</style>
